import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { useEffect, useRef, useState } from 'react';
import { getNotificacoes, readAllNotifications, readNotification } from '../../services/notificacoes.service';

import { useOutsideAlerter } from '../../hooks/outsideClickHook';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const notificationBeepSound = require('./notificationBeep.wav');

const notificationBeep = new Audio(notificationBeepSound);

function NotificationContent({ setNotificationsOpen, notification, setNotifications }: { setNotificationsOpen: any, notification: any, setNotifications: any }) {

  const navigate = useNavigate();

  const markNotificationAsRead = async () => {
    const updatedNotifications = await readNotification(notification.id);
    setNotifications(updatedNotifications.data);
  }


  const handleNotificationClick = async () => {
    await markNotificationAsRead();
    setNotificationsOpen(false);
    const endpoint = `/${notification.entityRoute}/${notification.entityId}`;
    console.log("Routing to endpoint: ", endpoint);
    navigate(endpoint, { state: { entityName: notification.entity } })
  }


  const NotificationHeader = () => {
    return (
      <div className='flex items-center'>

        {notification.state == 'Info' ?  <InfoIcon className='text-cyan-800' /> : <WarningIcon className={`${ notification.state === 'Danger'?'text-red-500' : 'text-yellow-600'}`} /> }
        <span className='font-bold text-[1.3em] ml-2'>{notification.entity}</span>

      </div>)
  }


  return (
    <div
  
      className='w-full bg-gray-300 hover:opacity-75 p-3 rounded-md'
      onClick={() => handleNotificationClick()}>

      <NotificationHeader />

      <div className='flex justify-between items-center'>

        <div className='w-3/4'>{notification.message}</div>
        <div className='flex mr-4 p-1 rounded border border-cyan-800 text-cyan-800 items-center hover:bg-cyan-800 hover:text-white'>
        <VisibilityIcon
          onClick={(e) => { e.stopPropagation(); markNotificationAsRead() }}
        />
        </div>

      </div>
      <div style={{ marginTop: '10px' }}>
        <span>{notification.created_at.split("T")[0]} {notification.created_at.split("T")[1].split(".")[0]}</span>
      </div>

    </div>
  )


}




export default function Notifications() {

  const [notifications, setNotifications] = useState([]);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [previousNotificationNumber, setPreviousNotificationNumber] = useState(0);

  const readNotifications = () => {
    readAllNotifications()
    .then((d) => {
        setNotifications([]);
    })

  }


  function updateNotifications(update : boolean) {
    getNotificacoes()
      .then((d => {
        setNotifications(d);
      }))
  }

  useEffect(() => {
    updateNotifications(false)

    const interval = setInterval(()=> {
      updateNotifications(true);
    }, 20000)

    return ()=> clearInterval(interval)
  }, [])


  useEffect(()=> {
    if(previousNotificationNumber < notifications.length ) {
      notificationBeep.play();
    }
    setPreviousNotificationNumber(notifications.length)
  }, [notifications])

  const notificationsRef = useRef(null);

  useOutsideAlerter(notificationsRef, () => setNotificationsOpen(false));


  const NotificationIcon = () => {

    return (
      <>
        {notifications.length == 0 ? <NotificationsIcon style={{ zIndex: 100 }} onClick={() => setNotificationsOpen(!notificationsOpen)} />
          : <div className='relative'>
            <NotificationsActiveIcon className='text-yellow-500 hover:opacity-40' onClick={() => setNotificationsOpen(!notificationsOpen)} />
            <div
              className='w-fit h-auto px-1 rounded-full bg-yellow-500 text-black absolute items-center content-center text-center text-sm font-bold  ml-4 mt-[-8px]'>
              {notifications.length}
            </div>
          </div>}
      </>
    )
  }



  return (
    <div className={`content-center justify-center cursor-pointer p-1 bg-rodrimaq-red-dark text-white rounded-xl hover:text-rodrimaq-red-dark hover:bg-white`}
      ref={notificationsRef}
    >
      <NotificationIcon/>
     
      {notificationsOpen ?
        <div className='absolute w-[600px] bg-zinc-400 text-black ml-4 mt-[-8px] z-[1000] rounded-md'>
          <div className='flex justify-between bg-rodrimaq-red-light'>
            <div className='p-3 font-bold  text-lg rounded-t-md'>Notificações ({notifications.length})</div>
            <div onClick={readNotifications} className='bg-zinc-500 text-white border rounded-md m-2 p-1 px-2 hover:bg-white hover:border-zinc-500 hover:text-zinc-500'>Limpar tudo</div>
          </div>
          <div className='overflow-y-auto max-h-[500px] border border-gray-400 rounded-b-md'>
            {notifications.map((n: any, idx: number) => {
              return (<div className='p-[2px]' key={idx}>
                <NotificationContent notification={n} setNotificationsOpen={setNotificationsOpen} setNotifications={setNotifications} />
                </div>)
            })}
          </div>

        </div> : null
      }


    </div>
  )



}